import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import { useDispatch, useSelector } from 'react-redux'
import Preloader from '../../../../components/elements/Preloader'
import { authHeader, tableHeadersFields } from '../../../../utils'
import axios from 'axios'
import { ERROR } from '../../../../store/types'
import PencilSquareIcon from '../../../../components/elements/icons/PencilSquareIcon'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import EditAssessmentDetails from '../../../../components/partials/assessments/EditAssessmentDetails'
import RecordAssessment from '../../../../components/partials/subjects/RecordAssessment'
import { clearCreatedAcademicSession } from '../../../../store/actions/academicSessionsActions'
import { clearUpdatedAssessment, fetchAssessmentRecords } from '../../../../store/actions/assessmentsActions'
import AssessmentsFilters from '../../../../components/elements/filters/AssessmentsFilters'
import ArrowUpTrayIcon from '../../../../components/elements/icons/ArrowUpTrayIcon'
import Loader from '../../../../components/elements/Loader'
import DataTable from '../../../../components/elements/DataTable'
import ApplicantTableSnippet from '../../../../components/partials/applications/ApplicantTableSnippet'
import StaffTableSnippet from '../../../../components/partials/staff/StaffTableSnippet'
import EmptyState from '../../../../components/elements/EmptyState'
import { fetchClasses } from '../../../../store/actions/classesDivisionsActions'
import ArrowDownTrayIcon from '../../../../components/elements/icons/ArrowDownTrayIcon'
import UploadAssessmentRecords from '../../../../components/partials/subjects/UploadAssessmentRecords'

const AssessmentDetails = () => {
    const [assessmentDetails, setAssessmentDetails] = useState(null)
    const {assessmentId} = useParams()
    const dispatch = useDispatch()
    
    const assessmentsSelector = useSelector(state => state.assessments)
    const classesSelector = useSelector(state => state.classes)

    const [loading, setLoading] = useState(true)
    const [reload, setReload] = useState(0)

    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(25)

    useEffect(() => {
        dispatch(fetchClasses('', 0, 0))
        const getAssessmentDetails = async () => {
            try {
                const headers = authHeader()
                
                setLoading(true)
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/assessments/${assessmentId}?expand=academicSession,term,createdBy`, { headers })            
                setAssessmentDetails(response.data.data)
                setLoading(false)
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setLoading(false)
            }
        }  
        if(assessmentsSelector.updatedAssessment && assessmentsSelector.updatedAssessment !== null) {
            setEditingAssessment(false)
            dispatch(clearUpdatedAssessment())
        }
        

        getAssessmentDetails()

        
        return () => {
            
        }

    }, [assessmentId, dispatch, reload, assessmentsSelector.createdAssessmentRecord, assessmentsSelector.updatedAssessment, page, perPage])

    const [filters, setFilters] = useState(``)

    useEffect(() => {
      
        dispatch(fetchAssessmentRecords(`assessment=${assessmentId}&${filters}`, page, perPage))

        if(assessmentsSelector.createdAssessmentRecord && assessmentsSelector.createdAssessmentRecord !== null) {
            setRecordingAssessment(false)
            dispatch(clearCreatedAcademicSession())
        }
            
        return () => {
            
        }
    }, [assessmentId, assessmentsSelector.createdAssessmentRecord, dispatch, filters, page, perPage])
    
    
    const doDelete = () => {

    }

    const [editingAssessment, setEditingAssessment] = useState(false)

    const [recordingAssessment, setRecordingAssessment] = useState(false)

    const [uploadingRecords, setUploadingRecords] = useState(false)

     const transactionColumnWidths = {
    student: 'w-4/12',
    "subject/class": 'w-2/12',
    recordedBy: 'w-4/12',
    // session: 'w-2/12',
    score: 'w-2/12',
    dateRecorded: 'w-2/12',
  }
      
  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{}
  }
  
  const columnDataStyles = {}

  const cleanupData = (dataSet) => {
    if(!dataSet) return []
    const data = []

    dataSet.forEach((item, itemIndex) => {
        data.push(
            {
              student: <ApplicantTableSnippet applicant={item.student} showAdmissionNumber={true} />,
              "subject/class": <div className="p-[5px]">
                <p className="text-[14px] mb-1">{item.subject.name}</p>
                <p>{item.class.class.name}</p>
              </div>,
              recordedBy: <StaffTableSnippet staff={item.recordedBy} hidePhoto />,
              score:
              <p className='font-space-grotesk font-medium text-[16px]'>
                <span className={`font-space-grotesk p-[5px] mr-[10px] rounded text-[14px] 
                  ${item.percentageScore >= 70 && 'bg-green-100 text-green-800' }
                  ${item.percentageScore >= 50 && item.percentageScore < 70 && 'bg-gray-100 text-gray-800' }
                  ${item.percentageScore < 50 && 'bg-red-100 text-red-800' }
                `}>
                  {item.percentageScore}%
                </span>
                {item.score}/<span className='text-gray-400'>{item.outOf}</span> 
              </p>,
            //   session: <p className='text-sm'>{item.academicSession.name} - {item.term.name}
            //   </p>,
              dateRecorded: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
            },
        )
    })

    return data
  }

    return (
        <>
            {loading ? 
                <Preloader />
                :
                <div className='w-full flex items-start gap-x-[10px]'>
                    <div className='p-[20px] rounded-[8px] bg-gray-50 w-[22%] border-2 border-vcm-purple border-opacity-30'>
                        <p className='font-space-grotesk font-[550]'>{assessmentDetails.name}</p>
                        <p className='text-sm text-gray-700 mt-[5px] mb-[20px]'>{assessmentDetails.description}</p>
                        

                        {assessmentDetails.type==='continuous-assessmentDetails' ? <span className='px-[10px] py-[5px] inline-block rounded bg-yellow-500 text-yellow-800 bg-opacity-10 text-xs font-medium font-space-grotesk'>
                        Continuous Assessment
                        </span>
                        :
                        <span className='px-[10px] py-[5px] inline-block rounded bg-green-500 text-green-800 bg-opacity-10 font-medium font-space-grotesk text-xs'>
                        Term Examination
                        </span>
                        }

                        <div className="my-4">
                            <p className='text-xs font-medium text-gray-500'>Total Marks</p> <p className='text-lg font-space-grotesk font-semibold text-gray-800'>{assessmentDetails.totalMarks}</p>
                        </div>

                        <div className='mt-[20px]'>
                            <p className='text-sm font-medium text-gray-600'>{assessmentDetails.term.name} - {assessmentDetails.academicSession.name}</p>
                            <p className='text-sm mt-[5px] font-medium text-gray-800'>From {moment(assessmentDetails.dates.from).format('LL')} to {moment(assessmentDetails.dates.to).format('LL')}</p>

                        </div>
                        <div className="w-full flex flex-row-reverse items-center gap-x-[5px] mt-5 border-t pt-3">
                        {/* <Link to={assessmentDetails._id} className='text-sm flex flex-row items-center gap-x-2 text-vcm-purple hover:text-gray-400 transition duration-200'>View Assessment Details<ArrowIcon className={`w-4 h-4`} /></Link>  */}
                            <button onClick={()=>{doDelete(assessmentDetails._id)}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-red-600'>
                                <TrashIcon className={`w-5 h-5`} />
                            </button>
                            <button onClick={()=>{setEditingAssessment(true)}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <PencilSquareIcon className={`w-5 h-5`} />
                            </button>
                        </div>
                    </div>

                    <div className='w-[75%] p-[20px]'>
                        <div className="w-full mx-auto flex items-center justify-between">
                            <div className='w-6/12'>
                                <h4 className='font-medium text-lg mb-3 text-gray-600'>Assessment Records</h4>
                                <div className='w-full'>
                                    <p className='text-gray-500 my-3 text-sm'>
                                        Set up continuous assessments for the college here. All assessment records will be created against these assessments here. You can click on an assessment to see more details and create assessment records.
                                    </p>
                                </div>
                            </div>
                            <div className='w-6/12 flex gap-x-2 flex-row-reverse'>
                                <button onClick={()=>{setRecordingAssessment(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                    <PlusIcon className='w-5 h-5' /> Create Record
                                </button>
                                <button onClick={()=>{setUploadingRecords(true)}} className='rounded px-4 py-3 mt-4 text-sm text-vcm-purple bg-vcm-light-purple transition duration-200 border border-vcm-purple hover:bg-purple-400 hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                    <ArrowUpTrayIcon className='w-5 h-5' /> Upload Records
                                </button>
                            </div>
                        </div>

                        <div className='w-full flex items-center justify-between mt-2 p-2 rounded-md border mb-[40px]'>
                            <div className='w-full'>
                                <AssessmentsFilters 
                                    applyFilters={(filters)=>{
                                        console.log('filters => ', filters)
                                        setFilters(filters)
                                    }} 
                                    filtersToHide={['academicSession']}
                                    classes={classesSelector?.classes?.classes}
                                />
                            </div>
                            <div className='w-[40%] flex flex-row-reverse gap-x-2'>
                                <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                                    <ArrowDownTrayIcon className={`w-5 h-5`} />
                                    Download Records (.csv)
                                </button>
                                {/* <div className='w-[350px]'>
                                <SearchField 
                                    placeholderText={`Search for invoice by name or invoice code`}
                                    showResultsDropDown={false}
                                    triggerSearch={(term)=>{searchApplicants(term)}}
                                    performingSearch={invoicesSelector.loadingInvoices}
                                />
                                </div> */}
                            </div>
                            </div>

                            {assessmentsSelector?.loadingAssessmentRecords ? 
                                <Loader />
                            :
                            <>
                            {assessmentsSelector?.assessmentRecords?.assessmentRecords?.length > 0 ? 
                                <div className='w-full'>
                                    <DataTable
                                        tableHeaders={tableHeadersFields(cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)[0]).headers} 
                                        tableData={cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)} 
                                        columnWidths={transactionColumnWidths}
                                        columnDataStyles={columnDataStyles}
                                        allFields={tableHeadersFields(cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)[0]).fields}
                                        onSelectItems={()=>{}}
                                        tableOptions={tableOptions}
                                        pagination={{
                                            perPage: perPage, 
                                            currentPage: page,
                                            totalItems: assessmentsSelector?.assessmentRecords?.total,
                                        }}
                                        changePage={(page) => {setPage(page)}}
                                        updatePerPage={(perPage) => {setPerPage(perPage)}}
                                    />
                                </div>
                            :
                                <div className='w-full'>
                                <EmptyState emptyStateText={`No scores recorded for this assessment yet. Subject teachers can record scores by clicking on record assessment above.`} />
                                </div>
                            }
                            </>}
                    </div>
                </div>
            }

            <ModalDialog
                shown={editingAssessment} 
                closeFunction={()=>{setEditingAssessment(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Update Assessment'
                maxWidthClass='xl:max-w-xl 2xl:max-w-lg'
                hideActions={true}
            >
                <EditAssessmentDetails 
                    assessment={assessmentDetails}
                    reload={()=>{setReload(reload+1)}}
                    close={()=>{setEditingAssessment(false)}}
                />
            </ModalDialog>

            <ModalDialog
                shown={recordingAssessment} 
                closeFunction={()=>{setRecordingAssessment(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Record student assessment score for ${assessmentDetails?.name} - ${assessmentDetails?.term?.name}, ${assessmentDetails?.academicSession?.name}`}
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <RecordAssessment assessment={assessmentDetails} close={()=>{setRecordingAssessment(false)}}  />
            </ModalDialog>

            <ModalDialog
                shown={uploadingRecords} 
                closeFunction={()=>{setUploadingRecords(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Upload student assessment scores for ${assessmentDetails?.name} - ${assessmentDetails?.term?.name}, ${assessmentDetails?.academicSession?.name}`}
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <UploadAssessmentRecords
                    assessment={assessmentDetails}
                    reload={() => {
                        setReload((prev) => prev + 1)
                    }}
                    close={()=>{setUploadingRecords(false)}}
                />
            </ModalDialog>
        </>
    )
}

export default AssessmentDetails